export default {
  customer_btn_add: '添加客户',

  // customer
  customer_title: '客户',
  customer_form_all_customer: '所有客户',
  customer_form_select_placehoder: '选择客户',
  customer_title_list: '站点列表',
  customer_title_user: '用户列表',
  customer_title_items: '个',

  // confirm
  customer_confirm_delete_title: '确定删除该客户?',
  customer_confirm_delete_content: '客户名称: {name}',

  customer_form_order_1: '客户名称',
  customer_form_order_2: '创建时间',
  customer_form_order_3: '更新时间',

  // table
  customer_table_site_created: '站点数',
  customer_table_user: '用户数',
  customer_table_platform: '平台客户',
  customer_table_read: '只读',

  // form
  customer_form_name: '客户名称',
  customer_form_name_placeholder: '请输入客户名称',
  customer_form_code: '客户编码',
  customer_form_code_placeholder: '请输入客户编码',
  customer_form_logo: '客户 Logo',
};
